import React from "react";

const TopicFilter = ({ topics, currentTopic, onTopicChange }) => (
    <div className="mt-6">
        <div className="flex items-center justify-between mb-3">
            <h2 className="text-sm font-semibold uppercase tracking-[0.18em] text-gray-500">
                Browse by topic
            </h2>
        </div>
        <div className="flex gap-3 overflow-x-auto pb-2 -mx-1 md:mx-0 hide-scrollbar">
            {topics.map((t) => (
                <button
                    key={t.id}
                    onClick={() => onTopicChange(t.id)}
                    className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 border ${currentTopic === t.id
                            ? "bg-red-600 text-white border-red-600 shadow-lg shadow-red-500/30"
                            : "bg-white text-gray-700 border-gray-200 hover:bg-red-50 hover:text-red-600"
                        }`}
                >
                    {t.label}
                </button>
            ))}
        </div>
    </div>
);

export default TopicFilter;
